export default __webpack_public_path__ + "static/media/gms.38935180.jpg";